import React, { useMemo } from 'react';
import { FreightsService } from 'service/FreightsService';
import { FREIGHTS } from 'helpers/routes';
import FreightSearchModel from 'models/freightSearch';
import SearchTabs, { SearchTabsConfig, SearchTabsProps } from 'components/common/SearchTabs';

export { NEW_TEMPLATE_ID } from 'components/common/SearchTabs';

type FreightSearchTabsProps = Omit<SearchTabsProps, 'config'>;

const FreightSearchTabs: React.FC<FreightSearchTabsProps> = (props) => {
  const config: SearchTabsConfig = useMemo(() => ({
    fetchTemplates: FreightsService.getCargoPatterns,
    deleteTemplate: FreightsService.deleteCargoPattern,
    updateTemplate: FreightsService.updateCargoPattern,
    getTemplate: FreightsService.getCargoPattern,
    prepareUpdateData: (template) => FreightSearchModel.updateTemplateData(FreightSearchModel.formData(template)),
    translationPrefix: 'freightSearch',
    mapRoute: FREIGHTS.map,
  }), []);

  return <SearchTabs config={config} {...props} />;
};

export default FreightSearchTabs;
